import React from 'react'
import Path from './Path'
import { multiplyPath } from './utils'

export default function Shape({ strokeColor, points, strokeWidth }) {
  let lines
  const isCurved = points.length >= 6
  if (isCurved) {
    lines = pathToCurves(points, strokeColor || '#000000', strokeWidth)
  } else {
    lines = pathToLines(points, strokeColor || '#000000', strokeWidth)
  }

  return <g className={'Shape'}>{lines}</g>
}

function pathToLines(path, strokeColor, strokeWidth) {
  const pairs = path
    .reduce((prev, next) => {
      if (!prev.length) {
        return [[null, next]]
      }
      return prev.concat([[prev[prev.length - 1][1], next]])
    }, [])
    .slice(1)

  return pairs.map((pair, index) => {
    const d = `M ${pair[0].x} ${pair[0].y} L ${pair[1].x} ${pair[1].y}`
    return (
      <g key={`g-${index}`}>
        <Path
          key={`path-${index}`}
          d={d}
          strokeColor={strokeColor}
          strokeOpacity={
            typeof pair[1].opacity === 'number' ? pair[1].opacity : 1
          }
          strokeWidth={
            typeof pair[1].width === 'number' ? pair[1].width : strokeWidth
          }
        />
        <path
          className="hitpath"
          d={d}
          fill="none"
          opacity={0.001}
          stroke={strokeColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={12}
        />
      </g>
    )
  })
}

function pathToCurves(path, strokeColor, strokeWidth) {
  // we need overlapping sets because we're using
  // multiple SVG paths / curves
  let overlappingSets = []

  let multipliedPath = multiplyPath(multiplyPath(path))

  const setSize = 4
  for (let i = 0; i < multipliedPath.length - (setSize - 1); i += setSize - 1) {
    const slice = multipliedPath.slice(i, i + setSize)
    if (slice.length === setSize) {
      overlappingSets.push(multipliedPath.slice(i, i + setSize))
    }
  }

  return overlappingSets.map((points, index) => {
    const M = `${points[0].x} ${points[0].y}`
    const C = `${points[1].x} ${points[1].y} ${points[2].x} ${points[2].y} ${points[3].x} ${points[3].y}`
    const d = `M ${M} C ${C}`
    const transformedStrokeWidth =
      typeof points[1].width === 'number' ? points[1].width : strokeWidth
    const opacity =
      typeof points[1].opacity === 'number' ? points[1].opacity : 1

    return (
      <g key={index}>
        <Path
          d={d}
          strokeColor={strokeColor}
          strokeWidth={transformedStrokeWidth}
          strokeOpacity={opacity}
        />
        <path
          className="hitpath"
          fill="none"
          stroke={strokeColor}
          d={d}
          strokeWidth={12}
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity={0.001}
        />
      </g>
    )
  })
}
